/*
1. To create Virtual Environment
    py -3 -m venv name or
    python3 -m venv name

2. Now activate the environment
    run ('relative path')venv/Scripts/Activate.ps1 on cmd
3.
    pip intsall fastapi
    pip install uvicorn
4.make a file main.py
5. run uvicorn main:app --reload
// */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Projects from "./Components/Projects";
import About from "./Components/About";
import Navbar from "./Components/Navbar";
import Skills from "./Components/Skills";
import "./index.css";
import Contact from "./Components/Contact";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div id="pageOuter">
        <Navbar />
        <Routes>
          <Route path="/" element={<About />}></Route>
          <Route path="/Projects" element={<Projects />}></Route>
          <Route path="/Skills" element={<Skills />}></Route>
          <Route path="/Contact" element={<Contact />}></Route>
        </Routes>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);
